var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-content',{class:_vm.$vuetify.theme.dark ? undefined : 'grey lighten-3',attrs:{"id":"pages"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }